import { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import { string } from "yup";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import { isNullOrEmpty } from "../../../config/ENV";
import Pagination from "../../../containers/pages/Pagination";
import { showLocalDateTime } from "../../../utilities/timeutility";
import {
  deleteJobBoardContactservice,
  updatejobBoardContactService,
  getJobBoardContactsService,
  addjobBoardContactService,
 
} from "../../../services/JobBoardService";
import {
  getPhoneNumberByCountryCode,
  validatePhoneNumber,
  formattedMobileNumber,
  getCountryCodefromMobile,
  getMobileNumberCountryCode,
} from "../../../utilities/phonenumberutility";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { formatPhoneNumber } from "../../../../src/utilities/phoneutility";
import { CgNotes } from "react-icons/cg";
import SvgUpArrow from "../../../components/svg/uparrow";
import SvgSelectedDownArrow from "../../../components/svg/selecteddownarrow";
import SvgSelectedUpArrow from "../../../components/svg/selecteduparrow";
import SvgDownArrow from "../../../components/svg/downarrow";
import Linkify from "react-linkify";

const JobBoardContacts = () => {
  let jobboardId = window.localStorage.getItem("jobboardId");
  let jobboardName = window.localStorage.getItem("jobboardName");

  const history = useHistory();
  const [modalRight, setModalRight] = useState(false);
  const [contact, setContact] = useState({
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    linkedInUrl: "",
    facebookUrl: "",
    twitterUrl: "",
  });
  const [phoneNumber, setPhoneNumber] = useState("");

  const [mobileNumber, setMoblieNumber] = useState("");
  const [mobileNumberCountryCode, setMobileNumberCountryCode] = useState("1");
  const [offinceMobileNumber, setOfficeMoblieNumber] = useState("");
  const [officeNumberCountryCode, setOfficeNumberCountryCode] = useState("1");

  const handlePhoneNumber = (value, country) => {
    setPhoneNumber(value);
    if (country != null) {
      let dialCode = country.dialCode;
      let countryCode = country.countryCode;
      let dialCodeLength = dialCode.length;
      let number = value.slice(dialCodeLength).replace(/\D/g, "");
      let mobileNumber = getPhoneNumberByCountryCode(number, countryCode);
      setMobileNumberCountryCode(dialCode);
      setMoblieNumber(mobileNumber);
    }
  };

  const [officeNumber, setOfficeNumber] = useState("");
  const handleOfficeNumber = (value, country) => {
    setOfficeNumber(value);
    if (country != null) {
      let dialCode = country.dialCode;
      let countryCode = country.countryCode;
      let dialCodeLength = dialCode.length;
      let number = value.slice(dialCodeLength).replace(/\D/g, "");
      let mobileNumber = getPhoneNumberByCountryCode(number, countryCode);
      setOfficeNumberCountryCode(dialCode);
      setOfficeMoblieNumber(mobileNumber);
    }
  };

  const [primaryNumber, setPrimaryNumber] = useState(false);
  const [remote, setRemote] = useState(false);
  const [jobBoardAddress, setjobBoardAddress] = useState([]);
  const [jobBoardLocation, setjobBoardLocation] = useState([]);
  const [locationId, setLocationId] = useState("");
  const [location, setLocation] = useState("");

  const [contactDetails, setContactDetail] = useState([]);
  const [size, setSize] = useState();
  const [contactId, setContactId] = useState();
  const [contactDetailid, setContactDetailId] = useState("");
  const [modalDelete, setModalDelete] = useState(false);
  const [contactName, setContactName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortBy, setSortBy] = useState("firstName");
  const [totalPage, setTotalPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState();
  const [search, setSearch] = useState("");
  const [modalBasic, setModalBasic] = useState(false);
  const [notesAdded, setNotesAdded] = useState("");
  const [notesList, setNotesList] = useState([]);
  const [jobBoardContact, setjobBoardContact] = useState("");
  const [selectedContact, setSelectedContact] = useState();
  const [contactNoteId, setContactNoteId] = useState();
  const [selectedNoteId, setSelectedNoteId] = useState("");
  const [isSortBySelected, setIsSortBySelected] = useState(false);

  let count = 0;

  useEffect(() => {
    let jobboardId = window.localStorage.getItem("jobboardId");
    if (jobboardId !== "") {
      
      getContacts(sortOrder, sortBy, currentPage, isSortBySelected);
     
    }
  }, [itemsPerPage, currentPage]);

  // useEffect(() => {
  //   if (!isNullOrEmpty(jobBoardContact)) {
  //     getNotes();
  //   }
  // }, [jobBoardContact]);

  const Back = () => {
    history.push("/jobboard");
  };

  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setContact((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };



  const AddContact = (reqObj) => {
    addjobBoardContactService(reqObj, jobboardId).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          toast.success("Contact added successfully");
          getContacts(sortOrder, sortBy, 1);
        }
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };

  const updateContact = (updateContactDetails) => {
    updatejobBoardContactService(updateContactDetails, jobboardId, contactId).then(
      (response) => {
        try {
          if (response.message != null) {
            if (response.data.error_message !== "") {
            }
          } else {
            toast.success("Contact updated successfully");
            getContacts(sortOrder, sortBy, 1);
          }
        } catch (err) {
          console.log("message" + JSON.stringify(err.message));
        }
      }
    );
  };

  
  function handleItemsPerChange(e, key) {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  }

  function onChangePage(e) {
    setCurrentPage(e);
  }
  const sortByJobs = (sb) => {
    setIsSortBySelected(true);
    setSortBy(sb);
    sortedOrder(sb, true);
  };

  const sortedOrder = (sb, isSortBySelected) => {
    var select = "";
    if (sortOrder === "desc") {
      setSortOrder("asc");
      select = "asc";
    } else {
      setSortOrder("desc");
      select = "desc";
    }
    getContacts(select, sb, currentPage, true);
  };

  const getContacts = (sortOrder, sortBy, pageNo, isSortBySelected) => {
    setCurrentPage(currentPage);
    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }

    if (sessionStorage.getItem("memberSortBy") !== null) {
      const sortByValue = sessionStorage.getItem("memberSortBy");
      if (!isNullOrEmpty(sortByValue)) {
        if (!isSortBySelected) {
          sortBy = sortByValue;
          setSortBy(sortBy);
        } else {
          sessionStorage.setItem("memberSortBy", sortBy);
        }
      } else {
        sessionStorage.setItem("memberSortBy", sortBy);
      }
    } else {
      sessionStorage.setItem("memberSortBy", sortBy);
    }

    if (sessionStorage.getItem("memberSortOrder") !== null) {
      const sortOrderValue = sessionStorage.getItem("memberSortOrder");
      if (!isNullOrEmpty(sortOrderValue)) {
        if (!isSortBySelected) {
          sortOrder = sortOrderValue;
          setSortOrder(sortOrder);
        } else {
          sessionStorage.setItem("memberSortOrder", sortOrder);
        }
      } else {
        sessionStorage.setItem("memberSortOrder", sortOrder);
      }
    } else {
      sessionStorage.setItem("memberSortOrder", sortOrder);
    }

    getJobBoardContactsService(
      jobboardId,
      search,
      itemsPerPage,
      currentPage,
      sortBy,
      sortOrder
    ).then((response) => {
      let size = response.data.size;
      if (size > 0) {
        setSize(size);
      } else {
        setSize(size);
      }
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data !== null) {
            var jobBoardContacts = response.data;
            // let size = jobBoardContact.size;
            // if (size > 0) {
            //   setSize(size);
            // } else {
            //   setSize(size);
            // }

            setContactDetail(jobBoardContacts.jobBoardContacts);
            const pages = Math.floor(size / itemsPerPage);
            if (Math.round(size % itemsPerPage) > 0) {
              const totalPages = pages + 1;
              setTotalPage(totalPages);
            } else {
              const totalPages = pages;
              setTotalPage(totalPages);
            }
          }

          // if (jobBoardContact != null) {
          //     setContactDetail(jobBoardContact.jobBoardContacts);

          //   const pages = Math.floor(size / itemsPerPage);
          //   if (Math.round(size % itemsPerPage) > 0) {
          //     const totalPages = pages + 1;
          //     setTotalPage(totalPages);
          //   } else {
          //     const totalPages = pages;
          //     setTotalPage(totalPages);
          //   }
          // }
        }
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };

  const updateContactDetail = (contactdetail) => {
    setModalRight(true);
    setContactId(contactdetail.id);
    if (contactdetail.title !== null || contactdetail.title !== "") {
      setContact((prevState) => ({
        ...prevState,
        title: contactdetail.title,
      }));
    }
    if (contactdetail.firstName !== null || contactdetail.firstName !== "") {
      setContact((prevState) => ({
        ...prevState,
        firstName: contactdetail.firstName,
      }));
    }
    if (contactdetail.lastName !== null || contactdetail.lastName !== "") {
      setContact((prevState) => ({
        ...prevState,
        lastName: contactdetail.lastName,
      }));
    }

    if (contactdetail.email !== null || contactdetail.email !== "") {
      setContact((prevState) => ({
        ...prevState,
        email: contactdetail.email,
      }));
    }
    if (
      contactdetail.linkedInUrl !== null ||
      contactdetail.linkedInUrl !== ""
    ) {
      setContact((prevState) => ({
        ...prevState,
        linkedInUrl: contactdetail.linkedInUrl,
      }));
    }
    if (
      contactdetail.facebookUrl !== null ||
      contactdetail.facebookUrl !== ""
    ) {
      setContact((prevState) => ({
        ...prevState,
        facebookUrl: contactdetail.facebookUrl,
      }));
    }
    if (contactdetail.twitterUrl !== null || contactdetail.twitterUrl !== "") {
      setContact((prevState) => ({
        ...prevState,
        twitterUrl: contactdetail.twitterUrl,
      }));
    }


    if (
      contactdetail.mobileNumber !== null ||
      contactdetail.mobileNumber !== ""
    ) {
      setPhoneNumber(contactdetail.mobileNumber);

      let countryCode = getCountryCodefromMobile(contactdetail.mobileNumber);
      setMobileNumberCountryCode(countryCode);

      let mobileNumber = getMobileNumberCountryCode(contactdetail.mobileNumber);
      setMoblieNumber(mobileNumber);
    }

    if (
      contactdetail.officeNumber !== null ||
      contactdetail.officeNumber !== ""
    ) {
      setOfficeNumber(contactdetail.officeNumber);

      let officeCountryCode = getCountryCodefromMobile(
        contactdetail.officeNumber
      );
      setOfficeNumberCountryCode(officeCountryCode);

      let officeMobileNumber = getMobileNumberCountryCode(
        contactdetail.officeNumber
      );
      setOfficeMoblieNumber(officeMobileNumber);
    }

    if (!isNullOrEmpty(contactdetail.location)) {
      setLocation(contactdetail.location.id);
    } else {
      setLocation("");
    }

    setPrimaryNumber(contactdetail.primaryContact);
    setRemote(contactdetail.remote);
  };

  const handleDeleteContact = (contact) => {
    setSelectedContact(contact.firstName);
    setContactDetailId(contact.id);
    setContactName(contact.firstName);
    setModalDelete(contact.id);
  };

  const deleteContact = () => {
    deleteJobBoardContactservice(contactDetailid, jobboardId).then((response) => {
      try {
        toast.success("Contact deleted successfully");

        let locationSize = contactDetails.length;
        let currentPageSize = currentPage;
        if (locationSize == 1) {
          if (currentPage !== 1) {
            currentPageSize = currentPage - 1;
          }
        }
        setCurrentPage(currentPageSize);
        getContacts(sortOrder, sortBy, 1);
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
      setModalDelete(false);
    });
  };
  function handleSearch(e, key) {
    setSearch(e.target.value);
  }
  const getSerialNumber = (index) => {
    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }
    return (currentPage - 1) * itemsPerPage + index + 1;
  };

  const displayTableHeaders = () => {
    return (
      <>
        <th className="w-5"> S.No </th>
        <th onClick={() => sortByJobs("firstName")} className="w-20">
          <Row className="w-[200]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> First Name </div>
            <div className="col">
              {sortBy === "firstName" ? (
                <>
                  {" "}
                  {sortBy === "firstName" ? (
                    sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          {" "}
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>
        <th onClick={() => sortByJobs("lastName")} className="w-15">
          <Row className="w-[200]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> Last Name </div>
            <div className="col">
              {sortBy === "lastName" ? (
                <>
                  {" "}
                  {sortBy === "lastName" ? (
                    sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          {" "}
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>
        <th className="w-5">Title</th>

        {/* <th onClick={() => sortByJobs("location")} className="w-10">
          <Row className="w-[150]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> Location</div>
            <div className="col">
              {sortBy === "location" ? (
                <>
                  {" "}
                  {sortBy === "location" ? (
                    sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          {" "}
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th> */}

        <th onClick={() => sortByJobs("remote")} className="w-10">
          <Row className="w-[100]">
            {" "}
            <div className="col pr-1 t-cursor-pointer">Remote</div>
            <div className="col">
              {sortBy === "remote" ? (
                <>
                  {" "}
                  {sortBy === "remote" ? (
                    sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          {" "}
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>

        <th onClick={() => sortByJobs("email")} className="w-15">
          <Row className="w-[150]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> E-mail </div>
            <div className="col">
              {sortBy === "email" ? (
                <>
                  {" "}
                  {sortBy === "email" ? (
                    sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          {" "}
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>
        <th className="w-20"> Mobile Number </th>
        <th className="w-20"> Office Number </th>
        <th className="w-10">Actions</th>
      </>
    );
  };

  const openModel = () => {
    setModalRight(true);
    setContactId("");
    setContact((prevState) => ({
      ...prevState,
      title: "",
      firstName: "",
      lastName: "",
      email: "",
      linkedInUrl: "",
      facebookUrl: "",
      twitterUrl: "",
    }));
    setPhoneNumber("");
    setOfficeNumber("");
    setPrimaryNumber(false);
    setLocation("");
    setRemote(false);

    setMoblieNumber("");
    setMobileNumberCountryCode("1");
    setOfficeMoblieNumber("");
    setOfficeNumberCountryCode("1");
  };

 
  const SubmitButton = () => {
    if (contact.firstName === "") {
      toast.error("Please enter first name");
      return;
    }

    if (contact.email !== "") {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(contact.email)) {
        toast.error("Please enter valid email");
        return;
      }
    }

    let _mobileNumber = "";
    if (!isNullOrEmpty(mobileNumber)) {
      if (!validatePhoneNumber(mobileNumber, "+" + mobileNumberCountryCode)) {
        toast.error("Please enter valid mobile number");
        return;
      } else {
        _mobileNumber = mobileNumberCountryCode + "-" + mobileNumber;
      }
    }

    let _officeMobileNumber = "";
    if (!isNullOrEmpty(offinceMobileNumber)) {
      if (
        !validatePhoneNumber(offinceMobileNumber, "+" + officeNumberCountryCode)
      ) {
        toast.error("Please enter valid office  number");
        return;
      } else {
        _officeMobileNumber =
          officeNumberCountryCode + "-" + offinceMobileNumber;
      }
    }

    const reqObj = {
      title: contact.title,
      firstName: contact.firstName,
      lastName: contact.lastName,
      email: contact.email,
      mobileNumber: _mobileNumber,
      officeNumber: _officeMobileNumber,
      linkedInUrl: contact.linkedInUrl,
      facebookUrl: contact.facebookUrl,
      twitterUrl: contact.twitterUrl,
      primaryContact: primaryNumber,
      remote: remote,
    };

    if (isNullOrEmpty(contactId)) {
      AddContact(reqObj);
    } else {
      updateContact(reqObj);
    }

    setModalRight(false);
  };

  const cancelButton = () => {
    setModalRight(false);
  };

  const openNoteModel = (id) => {
    setModalBasic(true);
    setjobBoardContact(id);
  };

  const displayPrimaryContact = (contactDetail) => {
    return (
      <>
        {contactDetail.primaryContact == true &&
        contactDetail.location == null ? (
          <>
            <strong className="t-cursor-pointer" title="Primary Contact">
              {formattedMobileNumber(contactDetail.mobileNumber)}
            </strong>
          </>
        ) : (
          <>{formattedMobileNumber(contactDetail.mobileNumber)}</>
        )}
      </>
    );
  };

  return (
    <>
      {" "}
      <Row>
        <Colxx xxs="12">
          <Card className="mt-2">
            {
              <Row>
                <Colxx xxs="12">
                  <div>
                    <CardHeader>
                      <div className="row">
                        <Colxx sm={10} style={{ padding: 0 }}>
                          <div className=" ml-3">
                            <h3 className="mt-2">
                              <b>{jobboardName}</b> | Job Board Contacts
                            </h3>
                          </div>
                        </Colxx>
                        <Colxx sm={2}>
                          <div className="btn-group float-right">
                            <Button
                              outline
                              size="sm"
                              color="primary"
                              onClick={Back}
                            >
                              Back
                            </Button>

                            <Button
                              color="primary"
                              className=""
                              size="sm"
                              outline
                              onClick={openModel}
                            >
                              Add
                            </Button>
                          </div>
                        </Colxx>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <Colxx className="mb-4">
                        <Row className="mt-2">
                          <Colxx sm={4} style={{ padding: 0 }}>
                            <InputGroup>
                              <Input
                                type=""
                                name=""
                                placeholder="Search"
                                onChange={handleSearch}
                                value={search}
                                className="form-control"
                              ></Input>
                              <InputGroupAddon addonType="append">
                                <Button
                                  outline
                                  color="primary"
                                  onClick={(e) => getContacts()}
                                >
                                  Search
                                </Button>
                              </InputGroupAddon>
                            </InputGroup>
                          </Colxx>
                          <Colxx sm={4}></Colxx>
                          <Colxx sm={4} className="address_page">
                            <Input
                              type="select"
                              value={itemsPerPage}
                              onChange={handleItemsPerChange}
                            >
                              <option value={""}>Items Per Page</option>
                              <option value={"10"}>10</option>
                              <option value={"25"}>25</option>
                              <option value={"50"}>50</option>
                              <option value={"100"}>100</option>
                            </Input>
                          </Colxx>
                        </Row>
                      </Colxx>
                      <Modal
                        className="t-W-500"
                        isOpen={modalRight}
                        toggle={() => setModalRight(!modalRight)}
                        wrapClassName="modal-right"
                      >
                        <Row>
                          <Colxx xxs="12">
                            <Card>
                              <CardBody>
                                <CardTitle>
                                  {contactId === "" ? (
                                    <strong>Add Job Board Contact</strong>
                                  ) : (
                                    <strong>Update Job Board Contact</strong>
                                  )}
                                </CardTitle>
                                <Form>
                                  <FormGroup row>
                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>
                                          First Name*
                                          {/* <span className="required-star"></span> */}
                                        </Label>
                                        <Input
                                          className="t-rounded-lg"
                                          type="firstName"
                                          name="firstName"
                                          data-testid="location-name"
                                          onChange={inputsHandler}
                                          value={contact.firstName}
                                        ></Input>
                                      </FormGroup>
                                    </Colxx>
                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>Last Name</Label>
                                        <Input
                                          className="t-rounded-lg"
                                          type="lastName"
                                          name="lastName"
                                          data-testid="location-name"
                                          onChange={inputsHandler}
                                          value={contact.lastName}
                                        ></Input>
                                      </FormGroup>
                                    </Colxx>
                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>Email</Label>
                                        <Input
                                          className="t-rounded-lg"
                                          type="email"
                                          name="email"
                                          data-testid="email"
                                          onChange={inputsHandler}
                                          value={contact.email}
                                        />
                                      </FormGroup>
                                    </Colxx>
                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>Title</Label>
                                        <Input
                                          className="t-rounded-lg"
                                          type="title"
                                          name="title"
                                          data-testid="location-title"
                                          onChange={inputsHandler}
                                          value={contact.title}
                                        ></Input>
                                      </FormGroup>
                                    </Colxx>
                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>Mobile Number</Label>
                                        <PhoneInput
                                          country="us"
                                          countryCodeEditable={false}
                                          type="text"
                                          name="phoneNumber"
                                          data-testid="location-phoneNumber"
                                          onChange={handlePhoneNumber}
                                          value={phoneNumber}
                                        />
                                      </FormGroup>
                                    </Colxx>
                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>Office Number</Label>
                                        <PhoneInput
                                          country="us"
                                          countryCodeEditable={false}
                                          type="text"
                                          name="phoneNumber"
                                          data-testid="location-phoneNumber"
                                          onChange={handleOfficeNumber}
                                          value={officeNumber}
                                        />
                                      </FormGroup>
                                    </Colxx>
                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>LinkedInUrl</Label>
                                        <Input
                                          className="t-rounded-lg"
                                          type="linkedInUrl"
                                          name="linkedInUrl"
                                          data-testid="location-title"
                                          onChange={inputsHandler}
                                          value={contact.linkedInUrl}
                                        ></Input>
                                      </FormGroup>
                                    </Colxx>
                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>FacebookUrl</Label>
                                        <Input
                                          className="t-rounded-lg"
                                          type="facebookUrl"
                                          name="facebookUrl"
                                          data-testid="location-facebookUrl"
                                          onChange={inputsHandler}
                                          value={contact.facebookUrl}
                                        ></Input>
                                      </FormGroup>
                                    </Colxx>
                                    <Colxx sm={12}>
                                      <FormGroup>
                                        <Label>TwitterUrl</Label>
                                        <Input
                                          className="t-rounded-lg"
                                          type="twitterUrl"
                                          name="twitterUrl"
                                          data-testid="location-twitterUrl"
                                          onChange={inputsHandler}
                                          value={contact.twitterUrl}
                                        ></Input>
                                      </FormGroup>
                                    </Colxx>

                                    <Colxx sm={12}>
                                      <FormGroup>
                                        <Label>
                                          <input
                                            data-testid="jobBoard-termsAndConditions"
                                            type="checkbox"
                                            className="inputterm"
                                            checked={primaryNumber}
                                            onChange={(e) =>
                                              setPrimaryNumber(e.target.checked)
                                            }
                                          />
                                          Primary Contact
                                        </Label>
                                      </FormGroup>
                                    </Colxx>

                                    <Colxx sm={12}>
                                      <FormGroup>
                                        <Label>
                                          <input
                                            data-testid="jobBoard-remote"
                                            type="checkbox"
                                            className="inputterm"
                                            checked={remote}
                                            onChange={(e) =>
                                              setRemote(e.target.checked)
                                            }
                                          />
                                          Remote
                                        </Label>
                                      </FormGroup>
                                    </Colxx>
                                  </FormGroup>
                                </Form>
                              </CardBody>
                            </Card>
                          </Colxx>
                        </Row>

                        <ModalFooter className="model-button modal-bottom-location">
                          <Button
                            color="primary"
                            size="sm"
                            outline
                            className="mt-4"
                            onClick={SubmitButton}
                          >
                            Save
                          </Button>

                          <Button
                            color="primary"
                            size="sm"
                            outline
                            className=" mt-4 ml-1"
                            onClick={cancelButton}
                          >
                            Cancel
                          </Button>
                        </ModalFooter>
                      </Modal>
                      <Colxx sm={12} className="mt-2 location-table p-0">
                        <div>
                          <div className="tableContainer">
                            <div className="tablewrapper">
                              <Table className=" hms_table jobRequisition_table table-responsive p-0 ">
                                <thead>
                                  <tr>{displayTableHeaders()}</tr>
                                </thead>

                                {contactDetails.length > 0 ? (
                                  contactDetails.map((contactDetail, index) => {
                                    return (
                                      <>
                                        <tbody>
                                          <tr>
                                            <td className="w-[60]" >
                                              {contactDetail.primaryContact ==
                                                true &&
                                              contactDetail.location == null ? (
                                                <>
                                                  <strong
                                                    className="t-cursor-pointer"
                                                    title="Primary Contact"
                                                  >
                                                    {getSerialNumber(index)}
                                                  </strong>
                                                </>
                                              ) : (
                                                <>{getSerialNumber(index)}</>
                                              )}
                                            </td>
                                            <td className="w-[120]">
                                              <u>
                                                {" "}
                                                <span
                                                  className="text-dark t-cursor-pointer"
                                                  title="Edit Contact"
                                                  onClick={() => {
                                                    updateContactDetail(
                                                      contactDetail
                                                    );
                                                  }}
                                                >
                                                  {" "}
                                                  {contactDetail.primaryContact ==
                                                    true &&
                                                  contactDetail.location ==
                                                    null ? (
                                                    <>
                                                      <strong
                                                        className="t-cursor-pointer"
                                                        title="Primary Contact"
                                                      >
                                                        {
                                                          contactDetail.firstName
                                                        }
                                                      </strong>
                                                    </>
                                                  ) : (
                                                    <>
                                                      {contactDetail.firstName}
                                                    </>
                                                  )}
                                                </span>
                                              </u>
                                            </td>
                                            <td className="w-[120]">
                                              {contactDetail.primaryContact ==
                                                true &&
                                              contactDetail.location == null ? (
                                                <>
                                                  <strong
                                                    className="t-cursor-pointer"
                                                    title="Primary Contact"
                                                  >
                                                    {contactDetail.lastName}
                                                  </strong>
                                                </>
                                              ) : (
                                                <>{contactDetail.lastName}</>
                                              )}
                                            </td>


                                            <td className="w-[60]">
                                              {contactDetail.primaryContact ==
                                                true &&
                                              contactDetail.location == null ? (
                                                <>
                                                  <strong
                                                    className="t-cursor-pointer"
                                                    title="Primary Contact"
                                                  >
                                                    {contactDetail.title}
                                                  </strong>
                                                </>
                                              ) : (
                                                <>{contactDetail.title}</>
                                              )}
                                            </td>

                                            <td className="w-[120]">
                                              {contactDetail.remote == true ? (
                                                <>
                                                  <strong
                                                    className="t-cursor-pointer ml-3"
                                                    title="Primary Contact "
                                                  >
                                                    <input
                                                      className=""
                                                      type="checkbox"
                                                      checked={true}
                                                    />
                                                  </strong>
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                            </td>

                                            <td className="w-[180]">
                                              {contactDetail.primaryContact ==
                                                true &&
                                              contactDetail.location == null ? (
                                                <>
                                                  <strong
                                                    className="t-cursor-pointer"
                                                    title="Primary Contact"
                                                  >
                                                    {contactDetail.email}
                                                  </strong>
                                                </>
                                              ) : (
                                                <>{contactDetail.email}</>
                                              )}
                                            </td>

                                            <td className="w-[120]">
                                              {displayPrimaryContact(
                                                contactDetail
                                              )}
                                            </td>
                                            <td className="w-[120]">
                                              {contactDetail.primaryContact ==
                                                true &&
                                              contactDetail.location == null ? (
                                                <>
                                                  <strong
                                                    className="t-cursor-pointer"
                                                    title="Primary Contact"
                                                  >
                                                    {formattedMobileNumber(
                                                      contactDetail.officeNumber
                                                    )}
                                                  </strong>
                                                </>
                                              ) : (
                                                <>
                                                  {formattedMobileNumber(
                                                    contactDetail.officeNumber
                                                  )}
                                                </>
                                              )}
                                            </td>
                                            <td className="w-[0]">
                                              <>
                                                <div className="actionbutton center flex">
                                                  <>
                                                   
                                                    <i
                                                      title="Delete Contact"
                                                      className="simple-icon-trash ic-profile text-dark delete-icon ml-2 emp_icon t-cursor-pointer"
                                                      onClick={() =>
                                                        handleDeleteContact(
                                                          contactDetail
                                                        )
                                                      }
                                                    />
                                                    {contactDetail.primaryContact ==
                                                    true ? (
                                                      <>
                                                        <span title="Primary Contact">
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="#FFA500"
                                                            viewBox="0 0 576 512"
                                                            className="ml-2 mb-1"
                                                          >
                                                            <path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" />
                                                          </svg>
                                                        </span>{" "}
                                                      </>
                                                    ) : (
                                                      <></>
                                                    )}
                                                  </>
                                                </div>
                                              </>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </>
                                    );
                                  })
                                ) : (
                                  <></>
                                )}
                              </Table>
                              {contactDetails == "" ||
                              contactDetails == null ? (
                                <>
                                  {" "}
                                  <p className="nodata-text">
                                    No job board contacts available
                                  </p>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </Colxx>
                      <hr></hr>
                      <Pagination
                        currentPage={currentPage}
                        totalPage={totalPage}
                        numberLimit={5}
                        firstIsActive={true}
                        onChangePage={(e) => onChangePage(e)}
                      />{" "}
                      <h3> Total matching records : {size} </h3>
                    </CardBody>
                  </div>
                </Colxx>

                <Separator className="mt-5 mb-5"></Separator>
              </Row>
            }
          </Card>
        </Colxx>
      </Row>
      <Modal isOpen={modalDelete} toggle={() => setModalDelete(!modalDelete)}>
        <ModalBody>
          Do you want to delete job board <strong>{" " + selectedContact}</strong>
          ?
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalDelete(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            size="sm"
            outline
            onClick={(e) => {
              deleteContact();
            }}
          >
            Delete
          </Button>
        </ModalFooter>
      </Modal>
   
     
    </>
  );
};
export default JobBoardContacts;
